import React, { useEffect } from 'react';
import { func, bool } from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import DEBreadcrumb from '../shared/DEBreadcrumb';
import ConfirmModal from '../shared/ConfirmModal';
import ConfirmRequestModal from '../shared/ConfirmRequestModal';
import Destinations from './Distro/Destinations';
import RequestDateSelector from './Distro/RequestDateSelector';
import RequestName from './Distro/RequestName';
import RequestQueue from './Distro/RequestQueue';
import SelectTarget from './Distro/SelectTarget';
import {
  resetDestErrors,
  setDistributeModal,
  setDeleteRequest,
  deleteDistributeCampaign,
  setComfirmRequest
} from '../../../actions/deActions/deDistributeActions';
import DeDialog from '../shared/DeDialog';
import UnsavedChangesContent from './Distro/UnsavedChangesContent';
import DistributeModalContent from './Distro/DistributeModalContent';
import { isModulePresent } from '../../../util/CommonUtils';
import { CAMP_TGTS_FEATUREID } from '../../../constants';

const DistributeView = ({
  routerLeaveModal,
  resetRouterLocation,
  confirmNavigation,
}) => {
  const { askForUnsavedChanges, isDistributeModalOpen, isDeleteRequest, isDeleteRequestName, isConfirmRequest } = useSelector(
    state => state.deDistribute,
  );
  const permissions = useSelector(state => state.userDetail.permissions);

  const dispatch = useDispatch();

  // clearing out errors on landing on Distribute page
  useEffect(() => {
    dispatch(resetDestErrors());
  }, []);

  const _handleDialogClose = () => {
    dispatch(setDistributeModal(false));
  };

  const hasPermission = isModulePresent(CAMP_TGTS_FEATUREID, permissions);

  const _handleCancelRequest = () => {
    dispatch(setDeleteRequest(false, null, ''));
  }

  const _handleDeleteRequest = () => {
    dispatch(deleteDistributeCampaign());
  }

  const _handleConfirmRequest = () => {
    dispatch(setComfirmRequest(false));
  }
  return (
    <div className="de--main distro">
      <div className="distro__row distro__row--root">
        <div className="distro__col distro__col-left">
          <RequestName />
          <SelectTarget />
          <RequestDateSelector />
          <Destinations />
        </div>
        <div className="distro__col distro__col-right">
          <DEBreadcrumb parent="DataHub / " child="Activate Campaign Targets" />
          <RequestQueue />
        </div>
      </div>
      {(askForUnsavedChanges || routerLeaveModal) && (
        <DeDialog
          className="de__unsaved--modal"
          open={askForUnsavedChanges || routerLeaveModal}
          title="Unsaved Changes"
          id="dialog-unsaved"
        >
          <UnsavedChangesContent
            confirmNavigation={confirmNavigation}
            resetRouterLocation={resetRouterLocation}
            routerLeaveModal={routerLeaveModal}
          />
        </DeDialog>
      )}
      {isDistributeModalOpen && (
        <DeDialog
          className="de__dest-modal"
          open={isDistributeModalOpen}
          onClose={_handleDialogClose}
          title={
            hasPermission
              ? 'Confirm Distribution Request'
              : 'Distribution Summary'
          }
          id="dialog-dest"
        >
          <DistributeModalContent
            hasPermission={hasPermission}
            onClose={_handleDialogClose}
          />
        </DeDialog>
      )}
      {isDeleteRequest && (
        <DeDialog
          className="de__confmodal"
          open={isDeleteRequest}
          title="Delete request"
          id="dialog-dest"
        >
          <ConfirmModal
            firstButtonClick = {_handleCancelRequest}
            secondButtonClick = {_handleDeleteRequest}
            modalMessage = {`Are you sure you want to permanently delete request: ${isDeleteRequestName}?`}
            firstButtonText = "No"
            secondButtonText = "Yes"
          />
        </DeDialog>
      )}
      {isConfirmRequest && (
        <DeDialog
          className="de__confmodal"
          open={isConfirmRequest}
          title="Confirmation request"
          id="dialog-dest"
        >
          <ConfirmRequestModal
            buttonClick = {_handleConfirmRequest}
            modalMessage = {`Thank you for submitting your request. You will receive an e-mail confirmation shortly.`}
            buttonText = "OK"
          />
        </DeDialog>
      )}
    </div>
  );
};

DistributeView.propTypes = {
  resetRouterLocation: func,
  routerLeaveModal: bool,
  confirmNavigation: func,
};

export default DistributeView;
